const BASE_URL_SERVER = `${process.env.VUE_APP_SERVER_URL}`;

import axios from "axios";

const API_ENDPOINT = {
    CHANGE_EMAIL: "/api/player/change-email",
    CHANGE_PASSWORD: "/api/player/change-password",
}

class UserPlayerService {
    changeEmail = (data) => {
        const userLocal = localStorage.getItem('user');
        const user = JSON.parse(userLocal);

        const config = {
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${user.jwt}`
            }
        };
        return axios.post(BASE_URL_SERVER + API_ENDPOINT.CHANGE_EMAIL, data, config);
    };

    changePassword = (data) => {
        const userLocal = localStorage.getItem('user');
        const user = JSON.parse(userLocal);

        const config = {
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${user.jwt}`
            }
        };
        return axios.post(BASE_URL_SERVER + API_ENDPOINT.CHANGE_PASSWORD, data, config);
    }
}

const userPlayerService = new UserPlayerService();
export default userPlayerService;